<template>
  <main class="sensors-page">
    <header class="sensors-header">
      <div>
        <p>Environmental monitoring</p>
        <h1>Sensors</h1>
      </div>
      <span>{{ appStore.state.sensors.length }} active</span>
    </header>

    <section class="sensors-grid" v-if="appStore.state.sensors.length > 0">
      <div class="sensor-card" :key="sensor.id" v-for="(sensor, index) in appStore.state.sensors">
        <gauge
          :value="sensor.valuesForDay[sensor.valuesForDay.length - 1].number"
          :allsensordata="sensor.valuesForDay"
          :id="sensor.id"
          :nickname="sensor.nickname"
          @update="
            ($event) => {
              appStore.state.sensors[index].nickname = $event.nickname;
              appStore.state.sensors[index].minCalibration = $event.minCalibration;
              appStore.state.sensors[index].maxCalibration = $event.maxCalibration;
              appStore.state.sensors[index].alertPercent = $event.alertPercent;
              appStore.state.sensors[index].emailsToAlert = $event.emailsToAlert;
            }
          "
          :emailNotifications="sensor.emailsToAlert"
          :minCalibration="sensor.minCalibration"
          :maxCalibration="sensor.maxCalibration"
          :alertPercent="sensor.alertPercent"
        />
      </div>
    </section>

    <article v-else class="empty-state">
      <span class="material-symbols-outlined" aria-hidden="true">sensors</span>
      <strong>No sensors connected</strong>
      <p>Sensor readings will appear here once a lab sensor starts reporting.</p>
    </article>
  </main>
</template>
<script>
import Gauge from "../../ui/GaugeComp.vue";
export default {
  components: { Gauge },
  data() {
    return {};
  },
  computed: {},
  methods: {
    getSensors() {
      const url = this.appStore.state.hostname + "/api/v1/sensors";

      const request = new Request(url, {
        credentials: "include",
        method: "GET",

        headers: { "content-type": "application/json" },
      });
      fetch(request)
        .then((resp) => resp.json())
        .then((data) => {
          if (data.status == "fail") throw new Error(data.message);
          else {
            console.log("data is", data.data.data);
            this.appStore.state.sensors = data.data.data;
            // console.log(this.noAdminUsers);

            //arrayOfDewars.value = data.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },

  //   created() {
  //     this.socket = io(this.appStore.state.hostname);

  //     this.socket.on("connect", () => {
  //       console.log("Connected to server");
  //       // Send the labId to the server to start listening for changes
  //       this.socket.emit("startListening", {
  //         labId: this.appStore.state.activeUser.labId.id,
  //       });
  //     });

  //     this.socket.on("documentUpdate", (data) => {
  //       console.log("Updated document:", data);
  //       // Handle the real-time update here (e.g., update your data or UI)
  //     });
  //   },
  //   unmounted() {
  //     this.socket.off("documentUpdate");
  //     this.socket.disconnect();
  //   },

  mounted() {
    this.getSensors();
  },
};
</script>
<style scoped>
.sensors-page {
  display: grid;
  align-content: start;
  gap: 12px;
  min-height: calc(100vh - 24px);
  padding: 12px;
  background: #fff;
  color: #172033;
  font-family: Montserrat, Inter, system-ui, sans-serif;
}

.sensors-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 18px;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #fff;
}

.sensors-header p,
.sensors-header h1 {
  margin: 0;
}

.sensors-header p {
  color: #64748b;
  font-size: 11px;
  font-weight: 900;
  text-transform: uppercase;
}

.sensors-header h1 {
  color: #172033;
  font-size: 20px;
  line-height: 1.15;
}

.sensors-header > span {
  min-height: 30px;
  padding: 6px 10px;
  border: 1px solid #dbe3ef;
  border-radius: 999px;
  background: #f8fafc;
  color: #335c8b;
  font-size: 12px;
  font-weight: 900;
}

.sensors-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 12px;
}

.sensor-card,
.empty-state {
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #fff;
}

.sensor-card {
  min-width: 0;
  overflow: hidden;
}

.empty-state {
  display: grid;
  justify-items: center;
  gap: 8px;
  max-width: 720px;
  padding: 34px 18px;
  color: #64748b;
  text-align: center;
}

.empty-state .material-symbols-outlined {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 999px;
  background: #e7eef7;
  color: #335c8b;
}

.empty-state strong {
  color: #172033;
  font-size: 18px;
}

.empty-state p {
  max-width: 420px;
  margin: 0;
  font-size: 13px;
  font-weight: 700;
}
</style>
